"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps;
    var isDisabled = compProps.isDisabled, required = compProps.required;
    var options = compData.options, value = compData.value;
    return { options: options, value: value, isDisabled: isDisabled, required: required };
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'compLayout'], function (_a, carmiProps) {
    var compProps = _a.compProps, compLayout = _a.compLayout;
    var direction = compProps.direction;
    var alignment = '';
    if (compProps.alignment === 'left') {
        if (direction === 'rtl') {
            alignment = 'flex-end';
        }
        else {
            alignment = 'flex-start';
        }
    }
    else if (compProps.alignment === 'right') {
        if (direction === 'rtl') {
            alignment = 'flex-start';
        }
        else {
            alignment = 'flex-end';
        }
    }
    else {
        alignment = compProps.alignment;
    }
    return {
        height: 'auto',
        'min-height': compLayout.height || 0,
        '--direction': direction,
        '--alignment': alignment,
        '--fnt': carmiProps['--fnt'],
    };
});
//# sourceMappingURL=SelectionTagsList.js.map